import trackingService from "../../../advanced-search/services/tracking/advancedSearchTrackingService";
import type { TitlesSelectionProps } from "../TitlesSelection/TitlesSelection";
import TitlesSelection from "../TitlesSelection/TitlesSelection";

type ExcludedTitlesProps = Pick<TitlesSelectionProps, "selectedItems" | "id" | "isReadOnly"> & {
    onChange(titles: string[]): void;
};

const ExcludedTitles = ({ onChange, ...rest }: ExcludedTitlesProps) => {
    function handleAdd(title: string) {
        trackingService.contactsFilters.trackProfileTitleAddedToExclude(title);
        onChange(rest.selectedItems.concat(title));
    }

    function handleRemove(title: string) {
        trackingService.contactsFilters.trackProfileTitleRemovedFromExclude(title);
        onChange(rest.selectedItems.filter((t) => t !== title));
    }

    return (
        <TitlesSelection
            {...rest}
            onAdd={handleAdd}
            onRemove={handleRemove}
            label={{ key: "si.contacts-search-profiles.label.exclude" }}
        />
    );
}

export default ExcludedTitles;
